import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { Drawer, Menu, MenuItem } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';
import ProfileIcon from './ProfileIcon';
import EQLogo1 from '../Screens/EQUINOCT-192x192.png'
import { useAuth0, LogoutOptions } from '@auth0/auth0-react';

interface MaterialAppBarProps {
  activeControl: string;
  setActiveControl: (view: string) => void;
  menuItems: string[];
}


const MaterialAppBar: React.FC<MaterialAppBarProps> = ({
  activeControl,
  setActiveControl,
  menuItems
}) => {
  const { logout } = useAuth0();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (item: string) => {
    if (item === 'logout') {
      logout({ returnTo: window.location.origin } as LogoutOptions);
    } else if (['map', 'analytics'].includes(item)) {
      setActiveControl(item);
    } else {
      console.warn(`Unknown menu item: ${item}`);
    }
    handleMenuClose();
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <div className='bg-zinc-900 bg-opacity-90'>
        <AppBar
          position="static"
          sx={{ backgroundColor: 'transparent', boxShadow: 'none' }}
        >
          <Toolbar>
            <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="menu"
              sx={{ mr: 2 }}
              onClick={handleMenuClick}
            >
              <MenuIcon />
            </IconButton>            
            <Drawer
              anchor="left"
              open={open}
              onClose={handleMenuClose}
              PaperProps={{
                style: {
                  width: '70vw',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                }
              }}
            >
              {/* Scrollable menu items */}
              <div style={{overflow : 'hidden'}}>
                {menuItems.map((item, index) => (
                  <li key={index} style={{ padding: '20px 0' }}>
                    <Link
                      to={`/${item.toLowerCase()}`}
                      className="no-underline font-inter black w-full block relative z-10 text-[25px] text-black"
                      style={{ padding: '10px 24px' }}
                      onClick={() => handleMenuItemClick(item)}
                    >
                      {item}
                    </Link>
                  </li>
                ))}
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '12px', paddingLeft : '20px', paddingBottom:'20px'}}>
                <img
                  src={EQLogo1}
                  alt="Logo"
                  style={{ width: '50px', height: '50px', objectFit: 'contain', borderRadius: '50%' }}
                />
                <Link
                  to="https://www.equinoct.com/"
                  className="no-underline font-inter text-black text-[23px]"
                >
                  EQUINOCT
                </Link>
              </div>
            </Drawer>

            <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
              Seasight
            </Typography>
            <ProfileIcon
              onClick={() => { navigate('/profile'); }}
            />
          </Toolbar>
        </AppBar>
      </div>
    </Box>
  );
}

export default MaterialAppBar;